<template>
  <div>
    <div>
      <span>{{ t('thisItemHasQty') }}</span>
      <span> (</span>
      <span style="color: black; font-weight: bold; direction: ltr; display: inline-block;">{{`${affectedStocks.map(i => i.quantity).join(', ')}`}}</span>
      <span>) </span>
      <span>{{ t('in') }}</span>
      <span> (</span>
      <span
          style="color: black; font-weight: bold;">{{ `${affectedStocks.map(i => ctx.locale == 'en' ? i.location.enName : i.location.arName).join(', ')}` }}</span>
      <span>) </span>
      <span>{{ t('switchingItToSerializeMsg') }}</span>
    </div>
    <div>
      {{ t('doYouWantToMsg') }}
    </div>

  </div>

</template>
<script setup lang="ts">
import {useContext} from "@/plugins/context";

const props = defineProps(['t', 'affectedStocks'])
const ctx = useContext();

</script>
<style scoped>
</style>


